import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../core/auth.service';
import { ConfigurationsService } from '../core/configurations.service';
import { map, take } from 'rxjs/operators';

export function adminGuard(): Observable<boolean> {
  const REQUIRED_GROUP = 'ADMIN';
  
  const authService = inject(AuthService);
  const router = inject(Router);
  const configurationsService = inject(ConfigurationsService);

  return configurationsService.getConfiguration().pipe(
    map(config => (config.keepergroups || []).map(group => group.code)),
    map(groupCodes => groupCodes.indexOf(REQUIRED_GROUP) !== -1),
    take(1)
  );
}
